import { WorkspaceAccessSubject, hasWorkspacePermission, onCapabilityPolicy } from './workspace-access';

/** Route by the selected membership, not the account's original registration role. */
export function workspacePortal(workspace: { orgRole?: string | null; portalMode?: string | null } | null | undefined): 'TENANT' | 'OWNER_PORTAL' | 'MAINTENANCE' | 'BACKOFFICE' {
  const role = workspace?.orgRole?.toUpperCase();
  const mode = workspace?.portalMode?.toUpperCase();
  if (role === 'TENANT_PORTAL') return 'TENANT';
  if (role === 'LANDLORD_PORTAL') return 'OWNER_PORTAL';
  if (role === 'MAINTENANCE_STAFF') return 'MAINTENANCE';
  if (mode === 'TENANT' || mode === 'OWNER_PORTAL' || mode === 'MAINTENANCE') return mode;
  return 'BACKOFFICE';
}

/** Portal routes describe capabilities, never internal role names. Record ownership is checked by the API. */
export const OWNER_ROUTE_PERMISSIONS: Readonly<Record<string, readonly string[]>> = {
  dashboard: ['ORG_VIEW'], transactions: ['PAYMENT_VIEW'], messages: ['ORG_VIEW'],
  properties: ['PROPERTY_VIEW'], financials: ['PAYMENT_VIEW'], statements: ['OWNER_STATEMENT_READ', 'OWNER_STATEMENT_SEND'],
  'tax-documents': ['OWNER_STATEMENT_READ'],
  maintenance: ['MAINTENANCE_VIEW'], inspections: ['INSPECTION_VIEW'], documents: ['DOCUMENT_VIEW'],
  approvals: ['MAINTENANCE_VIEW'], reports: ['REPORT_VIEW'], 'audit-trail': ['ORG_VIEW'],
  communications: ['COMMUNICATION_VIEW'], settings: ['PERSONAL_PREFERENCES_MANAGE', 'PORTAL_PROFILE_UPDATE'],
  support: ['SUPPORT_TICKET_MANAGE'],
};
export function ownerRouteAllowed(workspace: WorkspaceAccessSubject | null | undefined, path: string): boolean {
  if (!workspace) return false;
  const permissions = OWNER_ROUTE_PERMISSIONS[path.replace(/^\//, '').split(/[/?#]/)[0]];
  return !onCapabilityPolicy(workspace) || (!!permissions && hasWorkspacePermission(workspace, ...permissions));
}
